import init from '~~/common/js/client/analytics';

if (process.client) {
  if (!process.env.analyticsUrl) {
    throw new Error('Environment variable `analyticsUrl` is not set.');
  }
  init(process.env.analyticsUrl);
}
